/** Zen mode — hides all chrome, just content. */

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ZenState {
	isZen: boolean;
	toggle: () => void;
	exit: () => void;
}

export const useZenStore = create<ZenState>()(
	persist(
		(set) => ({
			isZen: false,
			toggle: () => set((s) => ({ isZen: !s.isZen })),
			exit: () => set({ isZen: false }),
		}),
		{ name: "omnios-zen" },
	),
);
